<template>
  <div class="list">
    <ul>
      <li v-for="(item, index) in list">
        <topic-item :data="item"></topic-item>
      </li>
    </ul>
  </div>
</template>

<script>
import TopicItem from '@/components/goods/topic/item'
export default {
  components: { TopicItem },
  data() {
    return {
      list: [],
      ids: decodeURIComponent(this.$route.query.ids)
    }
  },
  created() {
    if (this.ids) {
      this.$api
        .api_v3_album_list_by_ids_post({ data: { ids: this.ids.split(',') } })
        .then(e => {
          this.list = e
        })
    }
  }
}
</script>

<style scoped>
.list ul li {
  margin-bottom: 14px;
}
.list {
  padding: 14px 0;
}
</style>
